import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators, MinLengthValidator } from '@angular/forms';
import { NotificationService } from './notification.service';
import { AppService } from '../app.service';
import { ConfirmService } from '../shared/confirm/confirm.service';
import { Globals } from '../globals';
import { AuthenticationService } from '../auth';
import translateJson from "../../translate.json";

@Component({
    selector: 'notification-comp',
    providers: [NotificationService, ConfirmService, AppService], 
    templateUrl: './notification.component.html',  
    styleUrls: ['./notification.component.css']  
})

export class NotificationComponent {   
  
    private activeComponent: boolean;
    public showLoader: Boolean = false;
    lastUpdated: any;
    messages: any = [];
    // Get translation/text from customerJson
    public i18 = translateJson.i18;

    constructor(
        private service: NotificationService, 
        private confirmService: ConfirmService,
        private appService: AppService,
        private globals: Globals,
        private fb: FormBuilder,
        private authService: AuthenticationService) {
            this.authService.isAuthenticated();
        
        if(this.globals.userrole === 'ROLE_USERS' || this.globals.userrole === 'ROLE_ADMINS') {
            this.showLoader = true;
            this.service.getAllMessages().subscribe(
                data => this.setData(data),
                error => console.log(error),
                () => this.showLoader = false 
               )
            }
        }

    setData(data) {
        this.lastUpdated = data.lastUpdated;
        this.setMessageList(data.messages);
    }

    setMessageList(messages) {
        this.messages = messages;
        this.messages.forEach(msg => {
            let messageObj = this.checkValidJson(msg.messageText);
            if(messageObj !== false && typeof messageObj === 'object'){
                messageObj.prefix = this.appService.getTranslateValueFromKeyStr(messageObj.prefix, msg.entityType === 'rk' ? this.i18.notifications.rkPrefix : this.i18.notifications.suaPrefix);
                messageObj.suffix = this.appService.getTranslateValueFromKeyStr(messageObj.suffix, msg.entityType === 'rk' ? this.i18.notifications.rkSuffix : this.i18.notifications.suaSuffix);
                messageObj.level = this.appService.getTranslateValueFromKeyStr(messageObj.level, msg.entityType === 'rk' ? this.i18.notifications.rkClassificationText : this.i18.notifications.suaLevelText);
                msg.messageText = messageObj;
            }
            
        });
        
        let activeMessages = 0;
        for(let i = 0; i < this.messages.length; i++) {
            if(!this.messages[i].messageRead && !this.messages[i].messageDeleted) {
                activeMessages = activeMessages + 1;
            }
        }
        this.globals.messages = activeMessages;
    }

    setRoute(route) {
        let lastViewedComponent = JSON.parse(localStorage.getItem('lastComponent'));
        if(lastViewedComponent != undefined && lastViewedComponent != null) {
            localStorage.setItem('lastSearch', JSON.stringify([]));
            localStorage.setItem('filterList', JSON.stringify([]));
            localStorage.setItem('lastViewedPage', JSON.stringify(1));
            localStorage.removeItem('lastViewedAnchor');
        }
        this.appService.setRoute(route);
    }

    highlightMessage(messageId) {
        for(let i = 0; i < this.messages.length; i++) {
            if(messageId === this.messages[i].id) {
                this.messages[i].messageHighlighted = !this.messages[i].messageHighlighted;
                this.updateMessage(this.messages[i]);
            }
        }
    }

    readMessage(message) {
        if(message.readMessage) {
            return;
        } else {
            for(let i = 0; i < this.messages.length; i++) {
                if(message.id === this.messages[i].id) {
                    this.messages[i].messageRead = true;

                    this.updateMessage(this.messages[i]);
                }
            }
        }
    }
    
    markUnread(messageId) {
        for(let i = 0; i < this.messages.length; i++) {
            if(messageId === this.messages[i].id) {
                this.messages[i].messageRead = false;
                this.updateMessage(this.messages[i]);
            }
        }
    }

    deleteMessage(messageId) {
        this.confirmService.confirm(this.i18.notifications.noteConfirmDelete)
            .then(result => {
                if(result) {
                    for(let i = 0; i < this.messages.length; i++) {
                        if(messageId === this.messages[i].id) {
                            this.messages[i].messageDeleted = true;
                            this.updateMessage(this.messages[i]);
                        }
                    }
                }
            });
    }

    updateMessage(message) {
        if(typeof message.messageText === 'object'){
            let messageObj = {
                prefix: message.entityType === 'rk' ? 'i18.notifications.rkPrefix' : 'i18.notifications.suaPrefix',
                suffix: message.entityType === 'rk' ? 'i18.notifications.rkSuffix': 'i18.notifications.suaSuffix',
                level: message.entityType === 'rk' ? 'i18.notifications.rkClassificationText' : 'i18.notifications.suaLevelText',
                regarding: message.messageText.regarding,
                classification: message.messageText.classification,
            }
            message.messageText = JSON.stringify(messageObj)
        }
        this.service.updateMessage(message).subscribe(
            data => this.setMessageList(data.messages),
            error => console.log(error)
           ) 
    }

    checkValidJson(jsonStr){
        try {
            let jsonObj = JSON.parse(jsonStr);
            if(jsonObj && typeof jsonObj === 'object'){
                return jsonObj;
            }
        } catch (e) {
            return false;
        }
    }
}